const BUILDING_SELECT_ID = 'input_6_11';
const COMPANY_SELECT_ID = 'input_6_12';
const TOGGLE_ID = 'vtcrc-company-toggle';

function initBuildingFilter() {
    const buildingSelect = document.getElementById(BUILDING_SELECT_ID);
    const companySelect = document.getElementById(COMPANY_SELECT_ID);

    if (!buildingSelect || !companySelect || !window.vtcrcBuildingTenantMap) {
        return;
    }

    const map = window.vtcrcBuildingTenantMap;

    // Cache the full company list before we filter anything
    const allCompanies = Array.from(companySelect.options)
        .slice(1) // skip placeholder
        .map(opt => ({ text: opt.text, value: opt.value }));

    const placeholderText = companySelect.options[0]?.text || 'Choose Your Company';
    const placeholderValue = companySelect.options[0]?.value || '';

    let showingAll = false;

    // Create the toggle link below the company dropdown
    let toggle = document.getElementById(TOGGLE_ID);
    if (!toggle) {
        toggle = document.createElement('a');
        toggle.id = TOGGLE_ID;
        toggle.href = '#';
        toggle.style.cssText = 'display:none;font-size:0.875rem;margin-top:8px;cursor:pointer;color:#9B2242;text-decoration:none;transition:opacity 0.2s;';
        toggle.addEventListener('mouseenter', () => { toggle.style.opacity = '0.7'; });
        toggle.addEventListener('mouseleave', () => { toggle.style.opacity = '1'; });
        companySelect.parentNode.appendChild(toggle);
    }

    function isValidBuilding(value) {
        return value && map.hasOwnProperty(value);
    }

    function populateDropdown(companies) {
        companySelect.innerHTML = '';
        companySelect.add(new Option(placeholderText, placeholderValue));
        companies.forEach(t => {
            companySelect.add(new Option(t.text, String(t.value)));
        });
        companySelect.value = placeholderValue;
    }

    function filterCompanies() {
        const buildingId = buildingSelect.value;
        showingAll = false;

        if (isValidBuilding(buildingId)) {
            const filtered = map[buildingId];
            populateDropdown(filtered);
            companySelect.disabled = false;
            toggle.innerHTML = "My company isn&rsquo;t listed &rsaquo;";
            toggle.style.display = 'inline-block';
        } else {
            // No valid building selected — show all companies
            populateDropdown(allCompanies);
            companySelect.disabled = true;
            toggle.style.display = 'none';
        }
    }

    function showAllCompanies(e) {
        e.preventDefault();

        if (showingAll) {
            // Switch back to filtered
            showingAll = false;
            filterCompanies();
        } else {
            // Show full list
            showingAll = true;
            populateDropdown(allCompanies);
            companySelect.disabled = false;
            toggle.innerHTML = '&lsaquo; Show companies for this building';
        }
    }

    toggle.addEventListener('click', showAllCompanies);
    buildingSelect.addEventListener('change', filterCompanies);

    // Set correct initial state
    filterCompanies();
}

document.addEventListener('DOMContentLoaded', initBuildingFilter);

// Re-init after Gravity Forms AJAX re-renders (GF fires jQuery events, not native)
if (typeof jQuery !== 'undefined') {
    jQuery(document).on('gform_post_render', initBuildingFilter);
}
